<template>

    <div class="app-auth-login">

        <div class="card-header">
            <div class="icon" v-html="$icon('login-icon')"></div>
            <h1 class="title">{{ title || 'auth.login.title' | __ }}</h1>
        </div>

        <form class="form" @submit.prevent="send">

            <div
                v-if="errors.get('form')"
                class="form-error"
            >
                {{ errors.get('form') }}
            </div>

            <div class="form-row">

                <div class="form-row--item">
                    <app-input
                        v-model="form.idNumber"
                        :message="errors.get('idNumber')"
                        autofocus
                        label="inputs.idNumber"
                        type="number"
                    >
                    </app-input>
                </div>

                <div class="form-row--item">
                    <app-input
                        v-model="form.phoneNumber"
                        :disabled="phoneDisabled"
                        :message="errors.get('phoneNumber')"
                        label="inputs.phoneNumber"
                        t
                        type="number">
                    </app-input>
                </div>


            </div>

            <p class="description-message">
                {{ 'auth.login.description' | __ }}
            </p>

            <div class="submit-row">
                <app-button :disabled="empty" :loading="loading">
                    {{ 'auth.login.submit' | __ }}
                </app-button>
            </div>

        </form>

    </div>

</template>
<script>

export default {
    name: 'app-login',

    props: {
        phoneDisabled: Boolean,
        value: Object,
        title: String,
    },

    data() {
        return {
            loading: false,
            image: '',
            form: this.value,
            errors: this.$api.errors()
        }
    },

    watch: {
        form() {
            this.$emit('input', this.form);
        }
    },

    methods: {
        async send() {
            this.loading = true;

            const response = await this.$api.post('auth/send', this.form);
            this.errors = response.errors();

            if (!response.hasErrors()) {
                this.$emit('sent');
            }

            this.loading = false;
        }
    },

    computed: {
        empty() {
            return !(this.form.idNumber && this.form.phoneNumber);
        }
    },

    components: {}
}
</script>

<style lang="scss" scoped>

.title {
    font-size: larger !important;
}

.form {
    max-width: 580px;
    margin: 0 auto;

    .form-row {
        display: flex;
        padding: 0 25px;
        justify-content: space-between;

        @media all and (max-width: $mobile) {
            flex-direction: column;
            gap: 30px;
            padding: unset;
        }

        .form-row--item {
            padding: 15px;

            ::v-deep {
                label {
                    position: absolute;
                    top: -25px;
                }
            }
        }

    }

    .submit-row {
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .form-error {
        padding: 10px 20px;
        border-radius: 100px;
        background-color: $error-red;
        color: white;
        margin-bottom: 25px;
    }

}

</style>
